(() => {
    class CountrySwitcher extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector('#CountrySwitcherForm');
            this.inputCountry = this.form?.querySelector('input[name="country_code"]');
            this.returnInputs = this.form?.querySelectorAll('input[name="return_to"]');
            this.relatedProductHandle = this.dataset.relatedProd;
            this.country = this.dataset.country;
        }

        connectedCallback() {
           this.handleForm();
        }

        handleForm() {
            if (!this.form) return;
            this.querySelectorAll('.country-switcher__item').forEach(item => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (!this.relatedProductHandle || !this.inputCountry || !this.returnInputs?.length) return;

                    const newCountryCode = item.dataset.value;
                    if (!newCountryCode) return;

                    const currentUrl = new URL(window.location.href);
                    const parts = currentUrl.pathname.split('/').filter(Boolean);
                    const productsIdx = parts.indexOf('products');

                    if (productsIdx !== -1 && parts[productsIdx + 1]) {
                        parts[productsIdx + 1] = this.relatedProductHandle;
                    } else {
                        parts.push('products', this.relatedProductHandle);
                    }

                    const newPath = '/' + parts.join('/');
                    const newUrl = newPath + currentUrl.search + currentUrl.hash;

                    history.replaceState(null, '', newUrl);

                    this.inputCountry.value = newCountryCode;
                    this.returnInputs.forEach(input => {
                        input.value = newUrl;
                    });

                    this.form.submit();
                });
            });
        }
    }

    customElements.define('country-switcher', CountrySwitcher);
})()